import React, { useEffect, useRef } from 'react';
import { CardTheme } from '../../components/card';
import { RenderForm } from '../../components/forms';
import { useForm } from 'react-hook-form';
import { TextLarge } from '../../components/text';
import { ContainerButton } from '../../styles/global-style';
import { ButtonTheme } from '../../components/buttons';
import { FORM_SCAN_INCENTIVE } from './form';
import { useSelector } from 'react-redux';
import { useSubmitIncentive } from './hooks/useSubmitIncentive';
import { handleSubmitForm } from './func/submitHandler';
import { Spin } from 'antd';
import { useCheckBarcode } from './hooks/useCheckBarcode';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { branchOptionQuery } from '../../services/react-query/optionMasterQuery';

export const ScanIncentive = () => {
  const { control, setValue, getValues, handleSubmit, reset, watch } = useForm();
  const infoUser = useSelector((state) => state.info);
  const location = useLocation();
  const state = location.state;
  const isApiCalled = useRef(false);
  const { mutate: onSubmitIncentive, isPending: loadingSubmit } = useSubmitIncentive({
    reset,
    getValues,
  });
  const { mutate: checkBarcode, isPending: loadingCheckBarcode } = useCheckBarcode();

  const employeeWatch = watch('employeeId');
  const { data: branchOption } = branchOptionQuery(employeeWatch);

  useEffect(() => {
    if (infoUser) {
      setValue('employeeId', infoUser?.employeeId || '-');
      setValue('branchId', infoUser?.branchId ? Number(infoUser?.branchId) : undefined);
    }
  }, [infoUser, setValue]);

  useEffect(() => {
    if (state && !localStorage.getItem('refreshed')) {
      const branchId = state.result.branchId;
      localStorage.setItem('branchId', branchId);
      localStorage.setItem('refreshed', 'true');
      window.location.reload();
    }
  }, [state]);

  const handleOnEnterBarcode = (inputValue) => {
    if (!isApiCalled.current && inputValue.length === 16) {
      isApiCalled.current = true;
      checkBarcode({ barcodeValue: inputValue });
      setTimeout(() => {
        isApiCalled.current = false;
      }, 2000);
    }
  };

  const onSubmit = (values) => handleSubmitForm(values, onSubmitIncentive);

  return (
    <Spin spinning={loadingSubmit || loadingCheckBarcode}>
      <CardTheme>
        <TextLarge text="กรอกข้อมูลเลขที่ใบเสร็จ" />
        <RenderForm
          control={control}
          setValue={setValue}
          getValues={getValues}
          forms={FORM_SCAN_INCENTIVE({ onEnter: handleOnEnterBarcode, branchOption })}
        />
        <ContainerButton right>
          <ButtonTheme useFor="SUBMIT_INCENTIVE" onClick={handleSubmit(onSubmit)} />
          <ButtonTheme
            useFor="CANCEL"
            onClick={() =>
              reset({
                employeeId: getValues('employeeId'),
                branchId: getValues('branchId'),
                branchName: getValues('branchName'),
                barcodeValue: '',
                priceBill: '',
                slipImage: [],
              })
            }
          />
        </ContainerButton>
      </CardTheme>
    </Spin>
  );
};
